<template>
  <div class="content">
    <base-header class="pb-6 bg-primary">
      <b-row class="align-items-center py-4">
        <b-col cols="12">
          <h6 class="h2 text-white d-inline-block mb-0">Help Videos</h6>
        </b-col>
      </b-row>
    </base-header>
    <div class="container-fluid mt--6">
      <card>
        <div class="video-list">
          <!-- Add or edit videos here. Each block is one video. -->
          <!-- <div class="video-block">
            <h2 class="video-heading">Using Financeable with YourInsuranceHQ</h2>
            <video-player
              src="https://yourinsurancehq.com.au/wp-content/uploads/2026/08/financeable-overview-video-compressed-2.mp4"
            />
          </div> -->

          <div class="video-block">
            <h2 class="video-heading">Getting started</h2>
            <video-player
              src="https://yourinsurancehq.com.au/wp-content/uploads/2026/08/financeable-overview-video-compressed-2.mp4"
            />
          </div>

          <div class="video-block">
            <h2 class="video-heading">Creating a motor quote</h2>
            <video-player
              src="https://yourinsurancehq.com.au/wp-content/uploads/2026/08/financeable-overview-video-compressed-2.mp4"
            />
          </div>

          <div class="video-block">
            <h2 class="video-heading">Creating a P&E quote</h2>
            <video-player
              src="https://yourinsurancehq.com.au/wp-content/uploads/2026/08/financeable-overview-video-compressed-2.mp4"
            />
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "../components/VideoPlayer.vue";

export default {
  name: "Videos",
  components: {
    VideoPlayer,
  },
};
</script>

<style scoped>
.video-list {
  max-width: 850px;
  margin: 0 auto;
  text-align: center;
}

.video-block + .video-block {
  margin-top: 40px;
  padding-top: 32px;
  border-top: 1px solid #e9ecef;
}

.video-heading {
  color: black;
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
